import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { ArchivedDocumentsView } from "@containers/archivedDocuments/ArchivedDocumentsView";

const ArchivedSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="archivedDocuments">
            <ArchivedDocumentsView />
        </AuthenticatedLayout>
    );
}

export default ArchivedSessionsPage;
                            